export class FilterFunctions {

    static filterMatrix(matrix: any[], cellNames: string[], term: string): any[] {
        console.debug(matrix);
        const lowerTerm = term.toLowerCase();
        const result: any[] = [];
        for (const line of matrix) {
            if (FilterFunctions.has(line, cellNames, lowerTerm)) {
                result.push(line);
            }
        }
        return result;
    }

    private static has(line: any, cellNames: string[], term: string): boolean {
        for (const fieldName of cellNames) {
            const cell = line[fieldName];
            if (cell) {
                const value = (typeof cell === 'object' && 'value' in cell)
                    ? ('' + cell.value)
                    : ('' + cell);

                if (this.hasInString(value, term)) {
                    return true;
                }
            }
        }
        return false;
    }

    private static hasInString(value: string, term: string): boolean {
        return value.toLowerCase().indexOf(term) !== -1;
    }

}
